<div class="_dialog-title">
	<div class="flex-grow-1">{{offerGroup.title}}</div>
	<button mat-mini-fab mat-dialog-close color="accent">
		<mat-icon>close</mat-icon>
	</button>
</div>

<div class="_dialog-content">

	<div class="" style="padding: 0.5rem 1rem; font-size: 16px; font-weight: 600; font-style:italic; text-align:center; ">{{offerGroup.description}}</div>

	<div class="offers-menu-cat" style="border-bottom-width: 0;">
		<menu-offers-container class="">
			@for (offer of offerGroup.offers; track offer) {
			<div class="menu-offer"
				 [id]="'boffer_' + offer._id"
				 (mousedown)="selectOffer(offer, $event)"
				 [ngClass]="{'_active':$storage.order.offerCounters[offer.offer], '_folder':offer.type == 'folder', '_disabled': offer.stockDisabled}">
				<div class="menu-offer-body">
					<div class="_body">
						<div class="menu-offer-title">{{offer.name}}</div>
						<div class="menu-offer-description" *ngIf="offer.description_display != 'hide'">{{offer.description}}</div>
						<div class="menu-offer-price">
							@if (offer.price > 0) {
							<div class="_price">{{offer.price | lcurrency}}</div>
							} @else {
							<div class="_price"></div>
							}
							<app-offer-attributes [offer]="offer"></app-offer-attributes>
						</div>
					</div>
					<!--[class.no-image]="offer.iconImage" [appBgImage]="offer.imageURL" [model]="cat"-->
					<div class="_image" [ngStyle]="offer.catStyle || offer.cardStyle" [class.stock-disabled]="offer.stockDisabled">
						<img [appImageSrc]="offer.imageURL" [model]="offer" loading="lazy" />
						<app-offer-marketing [offer]="offer" [$storage]="$storage"></app-offer-marketing>
					</div>
				</div>
			</div>
			}
		</menu-offers-container>
	</div>
</div>

<div class="_bottom-actions border-top" *ngIf="!hideNext">
	<button type="button" mat-button class="_cancel" (mousedown)="closeApplyDialog(null)" *ngIf="hasCancel">
		{{'Cancel' | translate}}
	</button>
	<ng-container *ngIf="!hasCancel">
		<button type="button" mat-button class="_cancel" (mousedown)="closeApplyDialog(null)" *ngIf="!hasNext">
			{{nextCaption | translate}}
		</button>
		<button type="submit" mat-flat-button color="accent" class="rounded" (mousedown)="closeApplyDialog()" *ngIf="hasNext">{{nextCaption | translate}}</button>
	</ng-container>
</div>

